import {
    AppBar,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    MenuItem,
    TextField,
    Toolbar,
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { esEnteroODecimal } from '@infotrack/utilitarios/expresionesRegulares';
import TipoMovimientoDescripcion from 'Infotrack@Modelos/smartStock/tiposMovimientos/entidades/tipoMovimientoDescripcion';
import SelectItems from 'Infotrack@Transversales/componentes/selectItems';
import React from 'react';
import { IFormularioDocumentosDetalleVistaProps } from '../interfaces';

const FormularioDocumentoDetalleVista: React.FunctionComponent<IFormularioDocumentosDetalleVistaProps> = ({
    alCambiarValor,
    alCerrarReiniciarFormulario,
    alGuardarDocumentoDetalle,
    alSeleccionarItem,
    divisiones,
    documentoDetalle,
    estadoFormulario,
    esMovil,
    item,
    tipoFormularioDocumentoDetalle,
    tipoMovimiento,
}) => (
    <Dialog fullWidth maxWidth={esMovil ? 'lg' : 'sm'} open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        id={
                            tipoFormularioDocumentoDetalle === TipoFormulario.Creacion
                                ? 'gestionmovimientos.documentoDetalle.crearDetalleDocumento'
                                : 'gestionmovimientos.documentoDetalle.editarDetalleDocumento'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Card>
                <CardContent>
                    <Grid alignItems="center" container spacing={2}>
                        <Grid item xs={12}>
                            <SelectItems alSeleccionarItem={alSeleccionarItem} item={item} />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <TextField
                                fullWidth
                                label={
                                    <Texto
                                        display="inline"
                                        id="gestionmovimientos.documentoDetalle.CantidadSolicitada"
                                    />
                                }
                                name="CantidadSolicitada"
                                required
                                onChange={(e) =>
                                    esEnteroODecimal(e.target.value, { cantidadDecimales: 5, cantidadEnteros: 7 }) &&
                                    alCambiarValor(e)
                                }
                                value={documentoDetalle.CantidadSolicitada}
                                variant="outlined"
                                id={`CampoCantidadSolicitada-${documentoDetalle.ItemId}`}
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <TextField
                                disabled={tipoMovimiento === TipoMovimientoDescripcion.Entrada}
                                label={
                                    <Texto display="inline" id="gestionmovimientos.documentoDetalle.DivisionOrigen" />
                                }
                                fullWidth
                                name="DivisionOrigen"
                                required={tipoMovimiento !== TipoMovimientoDescripcion.Entrada}
                                onChange={alCambiarValor}
                                select
                                value={documentoDetalle.DivisionOrigen}
                                variant="outlined"
                                id={`CampoDivisionOrigen-${documentoDetalle.DivisionOrigen}`}
                            >
                                {divisiones.origen.length === 0 ? (
                                    <MenuItem value="">
                                        <Texto id="label.sinRegistros" />
                                    </MenuItem>
                                ) : (
                                    divisiones.origen.map(({ DivisionDescripcion, DivisionId }) => (
                                        <MenuItem key={DivisionId} value={DivisionId}>
                                            {DivisionDescripcion}
                                        </MenuItem>
                                    ))
                                )}
                            </TextField>
                        </Grid>
                        {item && item.Lotes && (
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    label={<Texto id="gestionmovimientos.documentoDetalle.Lote" />}
                                    name="Lote"
                                    onChange={alCambiarValor}
                                    value={documentoDetalle.Lote}
                                    variant="outlined"
                                    id={`CampoLote-${documentoDetalle.Lote}`}
                                />
                            </Grid>
                        )}
                        {item && item.Seriado && (
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    label={<Texto id="gestionmovimientos.documentoDetalle.Serial" />}
                                    name="Serial"
                                    onChange={alCambiarValor}
                                    value={documentoDetalle.Serial}
                                    variant="outlined"
                                    id={`CampoSerial-${documentoDetalle.Serial}`}
                                />
                            </Grid>
                        )}
                        {item && item.FEFO && (
                            <Grid item md={6} xs={12}>
                                <KeyboardDatePicker
                                    autoOk
                                    format="DD/MM/YYYY"
                                    required
                                    fullWidth
                                    label={<Texto id="gestionmovimientos.documentoDetalle.FechaVencimiento" />}
                                    okLabel={<Texto id="boton.cerrar" />}
                                    onChange={(fecha: any) =>
                                        alCambiarValor({
                                            target: { name: 'FechaVencimiento', value: fecha },
                                        } as React.ChangeEvent<HTMLInputElement>)
                                    }
                                    inputVariant="outlined"
                                    value={documentoDetalle.FechaVencimiento}
                                    variant="inline"
                                    id={`CampoFechaVencimiento-${documentoDetalle.FechaVencimiento}`}
                                />
                            </Grid>
                        )}
                    </Grid>
                </CardContent>
            </Card>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item xs="auto">
                    <Button color="secondary" onClick={() => alCerrarReiniciarFormulario(true)} variant="contained" id="boton-cancelar">
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item xs="auto">
                    <Button
                        color="primary"
                        onClick={alGuardarDocumentoDetalle}
                        variant="contained"
                        id={
                            tipoFormularioDocumentoDetalle === TipoFormulario.Creacion
                                ? 'boton-agregar'
                                : 'boton-editar'
                        }
                    >
                        <Texto
                            id={
                                tipoFormularioDocumentoDetalle === TipoFormulario.Creacion
                                    ? 'boton.agregar'
                                    : 'boton.editar'
                            }
                        />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioDocumentoDetalleVista;
